<template>

    <div id="company-info">
        <div id="logo text-center">
            <img alt="company logo" v-if="avatar_exists" class="mx-auto d-block img-fluid img-thumbnail"
                 :src="company_logo"/>
            <h5 class="text-center py-3" id="name">{{company_name}}</h5>
        </div>
        <div id="contact-details">
            <p class="location text-muted"><i class="fa fa-globe-europe fa-2x fa-fw"></i>&nbsp;
                {{company_country}}</p>
            <p v-if="company_location !== 'Not provided'" class="location text-muted"><i class="fa fa-map fa-2x fa-fw"></i>&nbsp;
                <a v-if="company_location !== 'Not provided'"
                :href="`https://maps.google.com/?q=${company_location}`" v-on:click="logCompanyLocation"
                target="_blank">{{company_location}}</a>
                <span v-if="company_location === 'Not provided'">{{$t(company_location)}}</span>
            </p>
            <p v-if="company_size !== 'Not provided'" class="location text-muted"><i class="fa fa-users fa-2x fa-fw"></i>&nbsp;
                {{company_size}}</p>

            <p v-if="company_format !== 'Not provided'" class="location text-muted"><i class="fa fa-building fa-2x fa-fw"></i>&nbsp;
                {{company_format}}</p>
            <h5 class="mt-3">{{contact_string}}</h5>
            <p class="text-muted"><i class="fa fa-envelope-open fa-2x fa-fw"></i>&nbsp;
                <a :href="`mailto:${company_email}`" v-on:click="logCompanyEmail">{{company_email}}</a></p>
            <p v-if="company_phone !== 'Not provided'" class="text-muted" v-on:click="logCompanyPhone"><i class="fa fa-phone-square fa-2x fa-fw"></i>&nbsp;
                {{company_phone}}
            </p>
            <p v-if="company_website !== 'Not provided'" class="text-muted"><i class="fa fa-globe fa-2x fa-fw"></i>&nbsp;
                <a v-if="company_website !== 'Not provided'" :href="prepareUrl(company_website)" target="_blank"
                   v-on:click="logCompanyWebsite">{{company_website}}</a>
                <span v-if="company_website === 'Not provided'">{{$t(company_website)}}</span></p>
            <p v-if="company_facebook !== 'Not provided'" class="text-muted"><i class="fab fa-facebook-square fa-2x fa-fw"></i>&nbsp;
                <a v-if="company_facebook !== 'Not provided'" :href="prepareUrl(company_facebook)" target="_blank"
                   v-on:click="logCompanyFacebook">{{company_facebook}}</a>
                <span v-if="company_facebook === 'Not provided'">{{$t(company_facebook)}}</span></p>
            <p v-if="company_twitter !== 'Not provided'" class="text-muted"><i class="fab fa-twitter-square fa-2x fa-fw"></i>&nbsp;
                <a v-if="company_twitter !== 'Not provided'" :href="prepareUrl(company_twitter)" target="_blank"
                   v-on:click="logCompanyTwitter">{{company_twitter}}</a>
                <span v-if="company_twitter === 'Not provided'">{{$t(company_twitter)}}</span></p>
            <p v-if="company_linkedin !== 'Not provided'" class="text-muted"><i class="fab fa-linkedin fa-2x fa-fw"></i>&nbsp;
                <a v-if="company_linkedin !== 'Not provided'" :href="prepareUrl(company_linkedin)" target="_blank"
                   v-on:click="logCompanyLinkedin">{{company_linkedin}}</a>
                <span v-if="company_linkedin === 'Not provided'">{{$t(company_linkedin)}}</span></p>
        </div>
    </div>

</template>
<script>
    export default {
        props: ['isAdminCompany', 'avatar_exists', 'company_country', 'company_name', 'company_logo', 'company_location', 'company_email', 'company_phone', 'company_website', 'company_facebook', 'company_twitter', 'company_linkedin', 'contact_string', 'offer_id', 'offer_type', 'company_size', 'company_format'],
        mounted() {
        },
        computed: {

        },
        methods: {
            prepareUrl: function (url) {
                var pattern = /^((http|https|ftp):\/\/)/;
                //let url = this.company_website;
                if (!pattern.test(url)) {
                    url = "http://" + url;
                }
                return url;
            },
            logCompanyLocation: function () {
                axios.post('/user/log-activity', {
                    location: this.company_location,
                    activity_type: 'click',
                    subject_id: this.offer_id,
                    subject_type: this.offer_type
                }).then(response => {
                }).catch(error => {
                });
            },
            logCompanyEmail: function () {
                axios.post('/user/log-activity', {
                    email: this.company_email,
                    activity_type: 'click',
                    subject_id: this.offer_id,
                    subject_type: this.offer_type
                }).then(response => {
                }).catch(error => {
                });
            },
            logCompanyWebsite: function () {
                axios.post('/user/log-activity', {
                    website: this.company_website,
                    activity_type: 'click',
                    subject_id: this.offer_id,
                    subject_type: this.offer_type
                }).then(response => {
                }).catch(error => {
                });
            },
            logCompanyFacebook: function () {
                axios.post('/user/log-activity', {
                    website: this.company_facebook,
                    activity_type: 'click',
                    subject_id: this.offer_id,
                    subject_type: this.offer_type
                }).then(response => {
                }).catch(error => {
                });
            },
            logCompanyTwitter: function () {
                axios.post('/user/log-activity', {
                    website: this.company_twitter,
                    activity_type: 'click',
                    subject_id: this.offer_id,
                    subject_type: this.offer_type
                }).then(response => {
                }).catch(error => {
                });
            },
            logCompanyLinkedin: function () {
                axios.post('/user/log-activity', {
                    website: this.company_linkedin,
                    activity_type: 'click',
                    subject_id: this.offer_id,
                    subject_type: this.offer_type
                }).then(response => {
                }).catch(error => {
                });
            },
            logCompanyPhone: function () {
                axios.post('/user/log-activity', {
                    phone: this.company_phone,
                    activity_type: 'click',
                    subject_id: this.offer_id,
                    subject_type: this.offer_type
                }).then(response => {
                }).catch(error => {
                });
            }
        }
    }
</script>

<style scoped>
    #company-info {
        background-color: #ebf2f7;
        padding: 1.8em;
    }

    #company-info i {
        vertical-align: middle;
        color: #005a93;
        padding-right: 0.2em;
    }
</style>
